module.exports = __webpack_public_path__ + "img/16.297d012e.jpg";